/*
export const environment = {
  production: true,
  api: 'http://dom436api.iterator.com.br',
  imagens_caminho: 'http://dom436.iterator.com.br/app/upload/imagens/',
};
*/

/*
export const environment = {
  production: true,
  api: 'http://af911api.tzslab.com',
  imagens_caminho: 'http://af911.tzslab.com/app_af911/upload/imagens/',
};
*/

export const environment = {
  production: true,
  api: 'https://halma199api.tzslab.com',
  imagens_caminho: 'https://halma199.tzslab.com/app_af199/upload/imagens/',
};

/*
export const environment = {
  production: true,
  api: 'https://demoapi.tzslab.com',
  imagens_caminho: 'https://demo.tzslab.com/app_demo/upload/imagens/',
};
*/

/*
export const environment = {
  production: true,
  api: 'https://sunsetapi.tzslab.com',
  imagens_caminho: 'https://sunset.tzslab.com/app_sunset/upload/imagens/',
};
*/

/*
export const environment = {
  production: true,
  api: 'https://santaceciliaapi.tzslab.com',
  imagens_caminho: 'https://santacecilia.tzslab.com/app_santacecilia/upload/imagens/',
};
*/